const i18n = require('./en-US');
export default i18n.default;



// WEBPACK FOOTER //
// ./src/i18n/i18n.js